import { AssetCategoryAPI } from "../api";
export class AssetCategory {
  constructor(props) {
    this.id = props.objectId || "";
    this.projectId = props.project.objectId || "";
    this.name = props.name || "";
    this.name_en = props.name_en || "";
  }
  static async getAssetCategory(payload) {
    const { data } = await AssetCategoryAPI.getAssetCategory(payload);
    const classesData = new AssetCategory(data.result);
    return classesData;
  }
  static async getAssetCategories(payload) {
    const { data } = await AssetCategoryAPI.getAssetCategories(payload);
    const classesData = data.result.map(item => new AssetCategory(item));
    return classesData;
  }
  static async updateAssetCategory(payload) {
    const { data } = await AssetCategoryAPI.updateAssetCategory(payload);
    const classesData = new AssetCategory(data.result);
    return classesData;
  }
  static async removeAssetCategory(payload) {
    const { data } = await AssetCategoryAPI.removeAssetCategory(payload);
    const classesData = new AssetCategory(data.result);
    return classesData;
  }
  static async createAssetCategory(payload) {
    const { data } = await AssetCategoryAPI.createAssetCategory(payload);
    const classesData = new AssetCategory(data.result);
    return classesData;
  }
}
